// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"60":"ecc8ee3450","253":"f1dba92189","619":"0a31422b71"}[chunkId] + ".js";
};